import { render, staticRenderFns } from "./CategoriaImagenView.vue?vue&type=template&id=a827466a&scoped=true"
import script from "./CategoriaImagenView.vue?vue&type=script&lang=js"
export * from "./CategoriaImagenView.vue?vue&type=script&lang=js"
import style0 from "./CategoriaImagenView.vue?vue&type=style&index=0&id=a827466a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a827466a",
  null
  
)

export default component.exports